import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  getCachedCompanyId,
  SERVICES_COMPANY_ID,
} from "../helpers/companyLabels"

export function useOrdersMenuLabel() {
  const { t } = useTranslation()
  const [companyId, setCompanyId] = useState(() => getCachedCompanyId())

  useEffect(() => {
    const onProfileLoaded = (e) => {
      const id = e.detail?.companyId ?? getCachedCompanyId()
      setCompanyId(id)
    }
    window.addEventListener("profile:loaded", onProfileLoaded)
    return () => window.removeEventListener("profile:loaded", onProfileLoaded)
  }, [])

  const isServicesCompany = Number(companyId) === SERVICES_COMPANY_ID
  return isServicesCompany ? t("orders.titleServices") : t("orders.title")
}
